import Rest from '../Rest'

export default class PaymentOrderService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/payment_orders'

  static build(vs = null) {
    return new this(this.resource, null, vs)
  }
}
